<template>
  <v-row class="rwd-margin py-5" no-gutters>
    <template v-if="loadingData">
      <v-col cols="12">
        <v-sheet width="100%" height="200" class="text-center pt-15">
          <v-progress-circular indeterminate color="grey" size="48" />
        </v-sheet>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" md="6" class="px-md-4 pb-5">
        <v-img
          :src="`${session.picBigArea}`"
          max-width="100%"
          class="d-none d-md-block area-image"
        />
        <v-img
          :src="`${session.picSmallArea}`"
          max-width="100%"
          class="d-block d-md-none area-image"
        />
      </v-col>
      <v-col cols="12" md="6" class="px-md-4">
        <template v-if="!loadingData && (!seatAreas.length || !tickets.length)">
          <h3 class="text-center ma-10 grey--text">
            {{ $t("group_seat_no_product") }}
          </h3>
        </template>
        <template v-else>
          <v-expansion-panels
            v-model="panel"
            :class="`seats-area ${panelActive ? 'is-select' : null}`"
          >
            <v-expansion-panel
              v-model="panel"
              v-for="(area, i) in seatAreas.filter(s => !s.hidden)"
              :key="`seat-area-${i}`"
              :class="{
                'is-disabled':
                  currentArea && hasSelect && currentArea.id !== area.id
              }"
            >
              <v-expansion-panel-header @click="e => selStActive(i, area)">
                <v-row no-gutters>
                  <v-col cols="8" class="d-flex align-center">
                    <div
                      class="area-color"
                      :style="{ backgroundColor: area.color || '#FFFFFF' }"
                    ></div>
                    <div class="d-flex align-center">
                      {{ area.name }}
                      <small
                        v-if="
                          (['pending', 'over', 'lock'].indexOf(area.status) ===
                            -1 &&
                            area.count !== null &&
                            area.count !== undefined &&
                            area.ticketAreaLimit &&
                            area.count <= 20) ||
                            area.status === 'soldout'
                        "
                        class="ml-1"
                        :class="
                          (!totalTicket && (!area.count || area.count <= 0)) ||
                          area.status === 'unavailable'
                            ? 'soldout'
                            : ''
                        "
                        >{{ $t("group_seat_remain") }}
                        {{
                          !area.count ||
                          area.count <= 0 ||
                          area.status === "unavailable"
                            ? 0
                            : area.count
                        }}
                      </small>
                      <v-chip
                        outlined
                        v-if="
                          area.status === 'onsale' &&
                            (area.count > 20 || !area.ticketAreaLimit)
                        "
                      >
                        {{ $t("order_step_1_hot_sale") }}</v-chip
                      >
                    </div>
                  </v-col>
                  <v-col
                    cols="4"
                    class="text-right"
                    :class="{
                      'text-regular': $vuetify.breakpoint.xs
                    }"
                    >NT.{{
                      area.price
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}</v-col
                  >
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-for="(ticket, i) in tickets">
                  <v-row
                    v-if="ticket.ticketAreaId === area.ticketAreaId"
                    :key="i"
                    no-gutters
                    :class="{
                      soldout:
                        !['onsale', 'pending', 'unavailable'].includes(
                          area.status
                        ) ||
                        !['onsale', 'pending'].includes(ticket.status) ||
                        (((['onsale'].includes(area.status) &&
                          !area.count &&
                          area.ticketAreaLimit) ||
                          (['onsale'].includes(ticket.status) &&
                            ticket.productLimit &&
                            !ticket.remain)) &&
                          !ticket.count) ||
                        (ticket.status !== 'pending' &&
                          ['pending', 'unavailable'].includes(area.status) &&
                          !area.count),
                      'text-title font-weight-regular': !$vuetify.breakpoint.xs
                    }"
                  >
                    <v-col
                      cols="8"
                      :class="{
                        'text-title': $vuetify.breakpoint.sm,
                        'text-small': $vuetify.breakpoint.xs
                      }"
                    >
                      <div>
                        <span>{{ ticket.name }}</span>
                        <div
                          class="ticket-price"
                          :class="{ 'text-regular': !$vuetify.breakpoint.xs }"
                        >
                          NT.
                          {{
                            ticket.price
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                        </div>
                      </div>
                      <v-tooltip top max-width="260">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-if="ticket.tips" v-bind="attrs" v-on="on">
                            <v-icon color="primary"
                              >mdi-information-outline</v-icon
                            >
                          </span>
                        </template>
                        <span>{{ ticket.tips }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col
                      cols="4"
                      align-self="center"
                      class="text-right"
                      :class="$vuetify.breakpoint.xs ? '' : 'pl-3'"
                    >
                      <span
                        v-if="ticket.status === 'pending'"
                        :class="
                          `font-weight-bold${
                            !!ticket.saleStart ? '' : ' ml-1 disabled-text'
                          }`
                        "
                      >
                        <template v-if="ticket.saleStart">
                          <div
                            class="text-nine"
                            v-html="
                              formatDateString(ticket.saleStart).replace(
                                ' ',
                                '<br/>'
                              )
                            "
                          ></div>
                          <div class="text-nine">
                            {{
                              $t(
                                `group_seat_sale_start${
                                  campaign.isLottery ? "_lottery" : ""
                                }`
                              )
                            }}
                          </div>
                        </template>
                        <template v-else>
                          {{ $t("session_table_pending") }}
                        </template>
                      </span>
                      <span
                        v-else-if="
                          ['restricted', 'lock'].includes(ticket.status)
                        "
                        class="ml-1 disabled-text"
                        >{{
                          $t(
                            `group_seat_lock${
                              campaign.isLottery ? "_lottery" : ""
                            }`
                          )
                        }}
                      </span>
                      <span
                        v-else-if="ticket.status === 'over'"
                        class="ml-1 disabled-text"
                        >{{
                          $t(
                            `group_seat_sale_over${
                              campaign.isLottery ? "_lottery" : ""
                            }`
                          )
                        }}
                      </span>
                      <span
                        v-else-if="
                          ['unavailable'].includes(ticket.status) ||
                            (['unavailable'].includes(area.status) &&
                              !(ticket.productLimit && !ticket.remain))
                        "
                        class="ml-1 disabled-text"
                      >
                        {{ $t("status_unavailable") }}
                      </span>
                      <span
                        v-else-if="
                          (ticket.status === 'onsale' &&
                            ticket.productLimit &&
                            !ticket.remain &&
                            !ticket.count) ||
                            ticket.status === 'soldout' ||
                            (area.ticketAreaLimit &&
                              area.count === 0 &&
                              !ticket.count)
                        "
                        class="ml-1 disabled-text"
                        >{{ $t("group_seat_soldout") }}
                      </span>
                      <div
                        v-else
                        class="
                          count-button
                          ml-auto
                          d-flex
                          justify-space-between
                          align-center
                        "
                      >
                        <v-btn
                          fab
                          depressed
                          x-small
                          @click="minusCount(i, ticket.id)"
                          :color="
                            canLess(i, ticket.id) ? 'light-primary-2' : 'grey-1'
                          "
                          :disabled="
                            ['over', 'lock'].includes(ticket.status) ||
                              ticket.status !== 'onsale' ||
                              (ticket.productLimit &&
                                !ticket.remain &&
                                !ticket.count)
                          "
                        >
                          <v-icon
                            :color="
                              canLess(i, ticket.id) ? 'primary-1' : 'grey-3'
                            "
                          >
                            mdi-minus
                          </v-icon>
                        </v-btn>
                        <div>
                          {{ ticket.count }}
                        </div>
                        <v-btn
                          fab
                          depressed
                          x-small
                          @click="addCount(i, ticket.id)"
                          :color="
                            canAdd(i, ticket.id) ? 'light-primary-2' : 'grey-1'
                          "
                          :disabled="
                            !['onsale', 'pending'].includes(area.status) ||
                              ['lock', 'over'].includes(ticket.status) ||
                              (ticket.productLimit &&
                                (!ticket.remain ||
                                  ticket.remain - ticket.unit < 0)) ||
                              (area.ticketAreaLimit &&
                                (area.count - ticket.unit < 0 ||
                                  !area.count)) ||
                              ticket.status !== 'onsale' ||
                              (!campaign.pickUp.includes('none') &&
                                !isInPostLimit &&
                                totalTicket >= 4)
                          "
                        >
                          <v-icon
                            :color="
                              canAdd(i, ticket.id) ? 'primary-1' : 'grey-3'
                            "
                          >
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- <div class="red-dash-divider rwd-margin"></div> -->
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Mixins from "./TicketMixins.vue";

export default {
  props: {
    refresh: Boolean,
    clear: Boolean,
    reselect: Boolean
  },
  mixins: [Mixins],
  data() {
    const dt = new Date();
    const timeString = `${dt.getFullYear()}/${dt.getMonth() +
      1}/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`;
    return {
      serialNumberErr: "",
      serialNumber: "",
      hasSerial: false,
      isSubmit: false,
      guarantee: false,
      tickets: [],
      hasSelect: false,
      panel: [],
      panelActive: false,
      currentArea: null,
      totalTicket: 0
    };
  },
  computed: {
    ...mapGetters({
      areaAssignment: "order/areaAssignment",
      isPopState: "order/isPopState",
      campaign: "event/campaign",
      session: "session/sessionInfo",
      couldCulturePoint: "culturePoint/couldCulturePoint"
    }),
    seatAssignmentInProd() {
      if (this.session.ticketArea) {
        return !!this.currentArea ? this.currentArea.seatAssignment : true;
      } else {
        return false;
      }
    }
  },
  watch: {
    async refresh(newVal, old) {
      if (newVal) {
        await this.productInit(true).then(() => {
          setTimeout(() => {
            this.$emit("refreshEnd");
          }, 500);
        });
      }
    },
    clear(newVal, oldVal) {
      if (newVal !== oldVal && newVal === true) {
        this.clearSelect();
        this.$emit("update", {
          selectedTickets: this.tickets.filter(t => t.count > 0),
          totalTicket: this.totalTicket,
          seatAssignmentInProd: this.seatAssignmentInProd
        });
      }
    },
    isPopState: {
      deep: true,
      handler: function(newVal, old) {
        if (old !== newVal && !newVal) {
          this.init();
        }
      }
    },
    reselect(newVal, old) {
      if (newVal && newVal !== old) {
        this.tickets = this.tickets.map(s => {
          if (s.count > 0) {
            this.currentArea.count += s.count;
            s.remain += s.count;
          }
          s.count = 0;
          return s;
        });
        this.resetSelect(true);
        this.$forceUpdate();
      }
    }
  },
  mounted() {
    this.productInit();
  },
  methods: {
    ...mapActions({
      buyTickets: "order/buyTickets",
      setAreaAssignment: "order/setAreaAssignment",
      setSeatAssignment: "order/setSeatAssignment",
      resetOrderState: "order/resetOrderState",
      setSelectedArea: "order/setSelectedArea",
      reserveTicket: "order/reserveTicket",
      setPopState: "order/setPopState",
      showDialog: "dialog/show",
      showLogIn: "login/show",
      logout: "user/logout",
      setCampaign: "event/setCampaign",
      setSession: "session/setSession",
      canCulturePoint: "culturePoint/canCulturePoint"
    })
  }
};
</script>

<style lang="scss">
@import "./ticket.scss";
</style>
